// Constantes del feature entregas

// Intervalo de polling para actualización de deliveries y marquesina (30s)
export const POLLING_INTERVAL = 30000;

// Intervalo de actualización del reloj en tiempo real (1s)
export const RELOJ_INTERVAL = 1000;

// Rutas especiales que requieren desglose de sub-rutas
export const RUTAS_ESPECIALES = ['isla', 'tenerife'];

// Claves de configuración para la marquesina
export const CONFIG_KEYS = {
    MARQUESINA: 'marquesina',
    MARQUESINA_DESP: 'marquesina_desp'
};
